export default {
  browse: '浏览',
  'recently-viewed': '最近查看',
  inspect: '检查',
  create: '创建',
  search: '搜索',
  'openmct-search': 'OpenMCT 搜索',
  save: '保存',
  cancel: '取消',
  edit: '编辑',
  close: '关闭',
  'open-new-tab': '在浏览器新标签页中打开',
  'fullscreen-enable': '启用全屏模式',
  'fullscreen-exit': '退出全屏模式',
  'tree-collapse-all': '折叠所有树项',
  'tree-show-selected': '在树中显示选中项',
  'clear-recently-viewed': '清除最近查看',
  'time-conductor': '全局时间控制器',
  'show-icon-only': '仅显示图标',
  'show-icon-and-name': '显示图标和名称',
  'display-as-single-line': '显示为单行',
  'display-as-multiple-lines': '显示为多行',
  searching: '正在搜索...',
  'no-results-found': '未找到结果',
  'no-items': '无项目',
  loading: '正在加载...',
  'create-modal-tree': '创建模态树',
  'main-tree': '主树',
  'browse-bar': '浏览栏',
  'nav-up-parent': '向上导航到父级',
  'browse-bar-object-name': '浏览栏对象名称',
  'locked-for-editing-by': '已由 {0} 锁定编辑',
  'locked-for-editing': '已锁定编辑',
  'click-to-unlock': '点击解锁',
  'unlocked-for-editing': '未锁定编辑，点击锁定',
  'locked-cannot-unlock': '已锁定编辑，无法解锁',
  'edit-object': '编辑对象',
  'save-finish': '保存并结束编辑',
  'save-continue': '保存并继续编辑',
  'cancel-editing': '取消编辑',
  'more-actions': '更多操作',
  'unsaved-changes-lost': '所有未保存的更改都将丢失。确定要继续吗？',
  ok: '确定',
  'saving-do-not-navigate': '正在保存，请勿离开此页面或关闭浏览器标签。',
  saving: '正在保存',
  'save-successful': '保存成功',
  'save-error': '保存对象时出错',
  'fields-marked-required': '所有标记为 {0} 的字段均为必填项。'
};
